import React, { Fragment, PureComponent, Suspense, useEffect, useState, startTransition } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { Button } from 'reactstrap';

// import config from '../../../../config.js';

// import PageContent from '../../components/content/PageContent.js';

import { getCmsPanelRequest, getPanelBySlugAndLanguage, memoizedGetPanelBySlugAndLanguage } from '../../CmsActions.js';
// import { getLoggedUser } from '../../../User/UserActions.js';
import { getDefaultLanguage } from '../../../Intl/IntlHelper.js';

import withIntl from '../../../../components/Intl/WithIntl.js';
import { getPanelModelViewer } from '../../CmsPanels.js';
import CmsEditLinks from '../form/CmsEditLinks.js';

function CmsPanel({ dispatch, intl, panel, slug = '', locale = null, isTemplate = false, defaultDisplay = null, displayEditLink = false, log = false, ...props }) {
	const setContent = () => {
		log && !isTemplate && !panel && console.log('CmsPanel::: setContent', slug, locale || intl.locale || getDefaultLanguage(), isTemplate, panel);
		return !isTemplate && !panel && dispatch(getCmsPanelRequest(slug, locale || intl.locale || getDefaultLanguage()));
	};

	// useEffect(() => {
	// log && console.log('CmsPanel::: Mounted', panel);
	// !panel && setContent();
	// }, []);

	useEffect(() => {
		log && console.log('CmsPanel::: Updated', slug, locale, intl.locale);
		log && console.log('CmsPanel::: Updated');
		setContent();
	}, [slug, locale, intl.locale, panel]);

	const renderPanel = () => {
		log && console.log('CmsPanel::: Panel exists ?', panel, defaultDisplay);
		if(panel && panel.blocks) {
			const ModelComponent = getPanelModelViewer(panel.model);
			return (
				<ModelComponent panel={panel} {...props} />
				// <Suspense fallback={<Loader hideContent />}>
				// 	<ModelComponent panel={panel} {...props} /> {/* eslint-disable-line */}
				// </Suspense>
			);
		}
		if(defaultDisplay) {
			return defaultDisplay;
		}
		if(process.env.NODE_ENV !== 'production') {
			return `CmsPanel ::: TODO ::: ${slug}`;
		}
		log && console.log('CmsPanel::: Panel not found !!', slug);
		return null;
	};

	log && console.log('CmsPanel::: Render', slug);
	// Remove inline onClick function: https://www.codementor.io/blog/react-optimization-5wiwjnf9hj#7-avoid-inline-function-definition-in-the-render-function
	// className={classNames(process.env.NODE_ENV === 'development' && ['border', 'border-2', 'border-info'])}>
	// if(panel && process.env.NODE_ENV === 'development') {
	// 	return (
	// 		<div className="position-relative">
	// 			{renderPanel()}
	// 			<Button color="link" tag={Link} to={`/fr/console/content/${panel._id}`} className="position-absolute" style={{ top: '0px', right: '-10px' }}>{panel.slug}</Button>
	// 		</div>
	// 	);
	// }
	return (
		<Fragment>
			{renderPanel()}
			{displayEditLink && <CmsEditLinks content={panel} />}
		</Fragment>
	);
}

function mapStateToProps(store, props) {
	return {
		panel: memoizedGetPanelBySlugAndLanguage(store, props.slug, props.locale || store.intl.locale),
		// user: getLoggedUser(store),
	};
}

// CmsPanel.defaultProps = {
//     panel: null,
//     // user: null,
//     locale: '',
//     isTemplate: false,
//     defaultDisplay: null,
// 	log: false,
// };

CmsPanel.propTypes = {
	dispatch: PropTypes.func.isRequired,
	intl: PropTypes.object.isRequired,
	slug: PropTypes.string.isRequired,
	panel: PropTypes.object,
	// user: PropTypes.object,
	locale: PropTypes.string,
	isTemplate: PropTypes.bool,
	defaultDisplay: PropTypes.any,
	displayEditLink: PropTypes.bool,
	log: PropTypes.bool,
};

// export default CmsPanel;
export default connect(mapStateToProps)(withIntl(CmsPanel));
